import React from "react"
import propTypes from "prop-types"
import { NavLink } from "react-router-dom"
import "./styles.scss"

const Nav = ({ navigation, className, planIsExist, isLogged, onSignOut }) => {
  const dependent = {
    planIsExist,
    isLogged
  }

  return (
    <nav className={["nav nav--horizontal", className].join(" ")}>
      <ul>
        {navigation &&
          navigation.map(item => {
            let el

            if (item.action === "signOut") {
              el = (
                <li key={item.id}>
                  <button onClick={onSignOut} type="button">
                    {item.title}
                  </button>
                </li>
              )
            } else {
              el = (
                <li key={item.id}>
                  <NavLink exact to={item.href} activeClassName="nav--active">
                    {item.title}
                  </NavLink>
                </li>
              )
            }

            if (item.dependent) {
              if (dependent[item.dependent]) {
                return el
              }
              return null
            }
            return el
          })}
      </ul>
    </nav>
  )
}

Nav.defaultProps = {
  navigation: [],
  className: "",
  planIsExist: false,
  isLogged: false,
  onSignOut: () => {}
}

Nav.propTypes = {
  navigation: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.number.isRequired,
      href: propTypes.string.isRequired,
      action: propTypes.string,
      title: propTypes.string.isRequired
    })
  ),
  className: propTypes.string,
  planIsExist: propTypes.bool,
  isLogged: propTypes.bool,
  onSignOut: propTypes.func
}

export default Nav
